import { logAnalyticsEvent } from '@/assets/js/firebase'

const CONTEXT_STORAGE_KEY = 'add_homescreen_context'

function readStoredContext () {
  if (typeof sessionStorage === 'undefined') {
    return { entry: '', task_id: '' }
  }

  try {
    const raw = sessionStorage.getItem(CONTEXT_STORAGE_KEY)
    if (!raw) return { entry: '', task_id: '' }
    const parsed = JSON.parse(raw)
    return {
      entry: parsed?.entry || '',
      task_id: parsed?.task_id || ''
    }
  } catch {
    return { entry: '', task_id: '' }
  }
}

function createParams ({ entry = '', taskId = '' } = {}) {
  const params = {}
  if (entry) params.entry = entry
  if (taskId) params.task_id = String(taskId)
  return params
}

export function setAddHomescreenContext ({ entry = '', taskId = '' } = {}) {
  const context = {
    entry: entry || '',
    task_id: taskId ? String(taskId) : ''
  }

  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(CONTEXT_STORAGE_KEY, JSON.stringify(context))
  }

  return context
}

export function getAddHomescreenContext () {
  return readStoredContext()
}

export function trackAddHomescreenBarShow () {
  logAnalyticsEvent('add_homescreen_bar_show', createParams({ entry: 'home_bar' }))
}

export function trackAddHomescreenClick ({ entry = '', taskId = '' } = {}) {
  setAddHomescreenContext({ entry, taskId })
  logAnalyticsEvent('add_homescreen_click', createParams({ entry, taskId }))
}

export function trackAddHomescreenIosGuideShow ({ entry = '', taskId = '' } = {}) {
  const context = entry || taskId ? { entry, taskId } : getAddHomescreenContext()
  logAnalyticsEvent('add_homescreen_ios_guide_show', createParams({
    entry: context.entry,
    taskId: context.task_id
  }))
}

export function trackAddHomescreenIosGuideClose ({
  entry = '',
  taskId = '',
  reason = 'user_close',
  lastStep = 1
} = {}) {
  const context = entry || taskId ? { entry, taskId } : getAddHomescreenContext()
  logAnalyticsEvent('add_homescreen_ios_guide_close', {
    ...createParams({
      entry: context.entry,
      taskId: context.task_id
    }),
    reason: reason || 'user_close',
    last_step: Math.min(4, Math.max(1, Math.floor(Number(lastStep) || 1)))
  })
}

export function trackAddHomescreenSuccess ({
  entry = '',
  taskId = '',
  result = 'accepted'
} = {}) {
  const context = entry || taskId ? { entry, taskId } : getAddHomescreenContext()
  logAnalyticsEvent('add_homescreen_success', {
    ...createParams({
      entry: context.entry,
      taskId: context.task_id
    }),
    result: result || 'accepted'
  })
}

export function trackAddHomescreenFail ({
  entry = '',
  taskId = '',
  failReason = 'unknown'
} = {}) {
  const context = entry || taskId ? { entry, taskId } : getAddHomescreenContext()
  logAnalyticsEvent('add_homescreen_fail', {
    ...createParams({
      entry: context.entry,
      taskId: context.task_id
    }),
    fail_reason: failReason || 'unknown'
  })
}

export function trackAddHomescreenPwaOpen ({ taskId = '' } = {}) {
  const context = getAddHomescreenContext()
  logAnalyticsEvent('add_homescreen_pwa_open', createParams({
    entry: context.entry,
    taskId: taskId || context.task_id
  }))
}
